import { render } from "./B2bNewUserExistEntities.vue?vue&type=template&id=3205a5c9&scoped=true&lang=pug"
import script from "./B2bNewUserExistEntities.vue?vue&type=script&lang=js"
export * from "./B2bNewUserExistEntities.vue?vue&type=script&lang=js"

import "./B2bNewUserExistEntities.vue?vue&type=style&index=0&id=3205a5c9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3205a5c9"]])

export default __exports__